import { w } from './global';

// Local types on purpose: adding these to the published Window type clashes with other libs (MP-25375).
type TConsentMetricsWindow = {
  dataLayer?: { p?: { t?: string } }[];
  navigator: Navigator & { userAgentData?: { mobile?: boolean } };
};

export enum CONSENT_LAYER {
  ONE = '1',
  TWO = '2',
}

export enum CONSENT_METRIC {
  MESSAGE_SHOWN = 'message_shown',
  CHOICE = 'choice',
}

export enum CONSENT_ACTION {
  ACCEPT_ALL = 'accept_all',
  REJECT_ALL = 'reject_all',
  PARTIAL = 'partial',
  SETTINGS = 'settings',
}

const CONSENT_METRICS_ENDPOINT = '/metrics/v1/consent';

export const getDeviceType = (navigator: TConsentMetricsWindow['navigator']): 'mobile' | 'desktop' =>
  (navigator.userAgentData?.mobile ?? /Mobi/i.test(navigator.userAgent)) ? 'mobile' : 'desktop';

export const sendConsentMetric = (
  name: CONSENT_METRIC,
  tags: { layer: CONSENT_LAYER; action?: CONSENT_ACTION },
): void => {
  try {
    const win = w as unknown as TConsentMetricsWindow;
    const { tenant } = w._sp_ss_config;
    const url = `${CONSENT_METRICS_ENDPOINT}?${new URLSearchParams({ platform: 'web', ...(tenant ? { tenant } : {}) })}`;
    // The dataLayer is on every page and does not depend on consent, unlike customGlobalConfig.
    const pageType = win.dataLayer?.find?.((item) => item?.p?.t)?.p?.t;
    const body = JSON.stringify({
      ...(pageType ? { pageName: pageType } : {}),
      metrics: [{ name, tags: { ...tags, deviceType: getDeviceType(win.navigator) } }],
    });

    // String, not Blob: the iOS TikTok in-app browser sends Blob beacon bodies empty.
    const queued = win.navigator.sendBeacon?.(url, body);
    if (!queued) {
      w.fetch(url, {
        method: 'POST',
        body,
        keepalive: true,
        headers: { 'Content-Type': 'application/json' },
      }).catch(() => undefined);
    }
  } catch {
    // Metrics must never break the consent flow.
  }
};
